import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styles: [],
    standalone: false
})
export class PrivacyComponent implements OnInit {
  ngOnInit(): void {}
}
